import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Zap, Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (new URLSearchParams(window.location.search).get("expired")) {
      toast.info("Your session expired. Please sign in again.");
    }
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      localStorage.setItem("bess_admin_token", r.data.token);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#FAFAFA] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-8">
          <span className="w-9 h-9 bg-volt flex items-center justify-center"><Zap className="w-5 h-5 text-black" strokeWidth={2.5} /></span>
          <span className="font-display font-black text-xl tracking-tighter">BESS BRIEF</span>
        </div>
        <div className="text-xs tracking-[0.2em] uppercase font-semibold text-[#A3A3A3] mb-2 flex items-center gap-2"><Lock className="w-3 h-3" /> Command Center</div>
        <h1 className="font-display font-black tracking-tighter text-3xl mb-8">Admin access</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <Input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none bg-[#111] border-2 border-[#262626] h-12 text-white focus-visible:ring-2 focus-visible:ring-volt focus-visible:ring-offset-0" data-testid="login-email" />
          <Input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none bg-[#111] border-2 border-[#262626] h-12 text-white focus-visible:ring-2 focus-visible:ring-volt focus-visible:ring-offset-0" data-testid="login-password" />
          <button type="submit" disabled={loading} className="w-full h-12 bg-volt text-black font-display font-bold uppercase tracking-tight transition-colors hover:bg-white disabled:opacity-50" data-testid="login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
